export default __webpack_public_path__ + "static/media/qrmaster-screenshot-06.24da44f9.png";